import { render, staticRenderFns } from "./unauthorized.vue?vue&type=template&id=c77da842&scoped=true"
import script from "./unauthorized.vue?vue&type=script&lang=js"
export * from "./unauthorized.vue?vue&type=script&lang=js"
import style0 from "./unauthorized.vue?vue&type=style&index=0&id=c77da842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77da842",
  null
  
)

export default component.exports